export const COPY_LIST_SETTINGS_MIGRATE_CURRENT_SPACE = 'yes-current-space';

export const COPY_LIST_SETTINGS_MIGRATE_ALL_SPACES = 'yes-all-spaces';

export const COPY_LIST_SETTINGS_NO = 'no';
